import React from "react";
import { ChevronDown, MapPin } from "lucide-react";
import { staffLists } from "./staffLists";

const STATUS_CONFIG = [
  {
    key: "online",
    label: "Online",
    bg: "bg-emerald-500/10 dark:bg-emerald-500/20",
    border: "border-emerald-200 dark:border-emerald-500/30",
    dot: "bg-emerald-500 dark:bg-emerald-400",
    text: "text-emerald-500 dark:text-emerald-400",
  },
  {
    key: "away",
    label: "Away",
    bg: "bg-yellow-500/10 dark:bg-yellow-500/20",
    border: "border-yellow-500/20 dark:border-yellow-500/30",
    dot: "bg-yellow-500 dark:bg-yellow-400",
    text: "text-yellow-500 dark:text-yellow-400",
  },
  {
    key: "offline",
    label: "Offline",
    bg: "bg-gray-500/10 dark:bg-gray-500/20",
    border: "border-gray-500/20 dark:border-gray-500/30",
    dot: "bg-gray-500 dark:bg-gray-400",
    text: "text-gray-500 dark:text-gray-400",
  },
];


const statusCount = staffLists.reduce(
  (acc, item) => {
    acc[item.status] = (acc[item.status] || 0) + 1;
    return acc;
  },
  { online: 0, away: 0, offline: 0 }
);


const StaffListCard = () => {
  return (
    <div>
      <div className="grid grid-cols-3 gap-3 mb-6">
        {STATUS_CONFIG.map((status) => (
          <div
            key={status.key}
            className={`flex items-center justify-between p-3 rounded-xl border
              ${status.bg} ${status.border}`}
          >
            <div className="flex items-center gap-2">
              <div className={`w-3 h-3 rounded-full status-dot ${status.dot}`} />
              <span className="text-[13px] font-medium dark:text-zinc-100">
                {status.label}
              </span>
            </div>

            <span className={`text-[18px] font-semibold ${status.text}`}>
              {statusCount[status.key]}
            </span>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-center gap-2 py-2 mb-2">
        <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full
                        bg-gradient-to-r from-emerald-50 to-purple-50
                        border border-emerald-200 ">
          <span className="text-[11px] text-muted-foreground dark:text-zinc-400 font-medium">
            Scroll to view all staff
          </span>
          <ChevronDown className="w-3.5 h-3.5 text-emerald-600 dark:text-emerald-400 animate-bounce" />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 max-h-[51vh] overflow-y-auto">
        {staffLists.map((staff, index) => (
            <div
              key={index}
              className="flex items-center gap-3 p-3 rounded-xl border
                border-slate-200 hover:bg-white
                hover:shadow-md transition-all"
            >
              <div className="relative">
                <div className="w-12 h-12 rounded-full border-2 border-slate-200
                  flex items-center justify-center text-[13px] bg-green-50">
                  {staff.name?.split(" ")
                    .map((n) => n[0])
                    .join("")}
                </div>
                <span
                  className={`absolute bottom-0 right-0 w-3.5 h-3.5 border-2 border-white status-dot ${staff.status.toLowerCase()}`}
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[14px] font-semibold truncate dark:text-zinc-100">
                  {staff.name}
                </p>
                <p className="text-[12px] text-muted-foreground truncate">
                  {staff.role}
                </p>

                <div className="flex items-center gap-1 mt-1">
                  <MapPin className="w-3 h-3 text-muted-foreground" />
                  <span className="text-[12px]">{staff.flag}</span>
                  <div className={`w-2 h-2 rounded-full status-dot ${staff.country.toLowerCase().replace(/\s+/g, "-")}`} />
                  <span className="text-[11px]">
                    {staff.country}
                  </span>
                </div>
              </div>

              <div className="flex flex-col items-end gap-1">
                <span
                  className={`text-[10px] px-2 py-0.5 text-white status-indicator
                    ${staff.status}`}
                >
                  {staff.status}
                </span>
                <span className="text-[10px]">
                  {staff.lastSeen}
                </span>
              </div>
            </div>
          ))}
      </div>
    </div>
    
        
  );
};

export default StaffListCard;
